import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ethers } from "ethers";
import { ADDRESSES, ABIS } from "../utils/contracts";

export default function FakeNefturiansUser() {
  const { userAddress } = useParams();
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserTokens = async () => {
      if (!window.ethereum) return;
      const provider = new ethers.BrowserProvider(window.ethereum);
      const contract = new ethers.Contract(ADDRESSES.NEFTURIANS, ABIS.NEFTURIANS, provider);

      try {
        const balance = await contract.balanceOf(userAddress);
        const foundTokens = [];

        // Loop through tokens assuming Enumerable extension
        for (let i = 0; i < balance; i++) {
          const tokenId = await contract.tokenOfOwnerByIndex(userAddress, i);
          
          // Get Metadata for each
          let uri = await contract.tokenURI(tokenId);
          uri = uri.replace("ipfs://", "https://ipfs.io/ipfs/");
          
          const metaRes = await fetch(uri);
          const meta = await metaRes.json();
          
          foundTokens.push({
            id: tokenId.toString(),
            name: meta.name,
            description: meta.description,
            image: meta.image.replace("ipfs://", "https://ipfs.io/ipfs/")
          });
        }
        setTokens(foundTokens);
      } catch (err) {
        console.error("Error fetching tokens:", err);
      }
      setLoading(false);
    };

    fetchUserTokens();
  }, [userAddress]);

  if (loading) return <p>Loading tokens...</p>;

  return (
    <div>
      <h2>Tokens for {userAddress.slice(0, 6)}...</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {tokens.map((t) => (
            <div key={t.id} style={{ border: "1px solid #ccc", padding: "10px", width: "200px" }}>
                <img src={t.image} alt={t.name} style={{ width: "100%" }} />
                <h3>{t.name}</h3>
                <p>{t.description}</p>
            </div>
        ))}
      </div>
      {tokens.length === 0 && <p>No tokens found.</p>}
    </div>
  );
}